import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useFrame } from '../contexts/FrameContext';
import CssLanding from './CssLanding';
import { supabase } from '../lib/supabase';

const QueryRedirect: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setIsOrientaAddress, setIsChapelHouse, setContextAddress } = useFrame();
  const searchParams = new URLSearchParams(location.search);
  const propertyCode = searchParams.get('code');

  useEffect(() => {
    const fetchProperty = async () => {
      if (!propertyCode) return;

      const { data: property } = await supabase
        .from('properties')
        .select('*')
        .eq('property_code', propertyCode)
        .single();

      if (property) {
        if (property.address.toLowerCase().includes('2 chapel hill')) {
          setIsOrientaAddress(false);
          setIsChapelHouse(true);
          setContextAddress(property.address);
        }
        navigate('/configure');
      }
    };

    if (propertyCode) {
      fetchProperty();
    }
  }, [propertyCode, navigate, setIsOrientaAddress, setIsChapelHouse, setContextAddress]);

  // If no code is present, show the landing page
  if (!propertyCode) {
    return <CssLanding />;
  }

  // Show loading state while redirecting
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-gray-500">Loading...</div>
    </div>
  );
};

export default QueryRedirect;